  import React, { useState, useEffect } from 'react';

  import ApiService from "../../../services/api.service";

  import {Elements} from '@stripe/react-stripe-js';
  import {loadStripe} from '@stripe/stripe-js';
  import CheckoutForm from './CheckoutForm';

  import Spinner from '../../../common/spinner';
  
  export default function Stripe({member, transactionId, locationData, goNextStep, localStorageDatas}) {

    const [clientSecret, setClientSecret] = useState("");
    const [stripePromiseObj, setStripePromise] = useState("");
    const [stripeOptionsObj, setStripeOptions] = useState("");

    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);

    const [subscriptionTransaction, setSubscriptionTransaction] = useState();

    var stripeOptions = {};

    //const mainStripePromise = null;

    let primaryMember = {};

    for(let i=0;i<localStorageDatas.members.length;i++) {
        let memberRec = localStorageDatas.members[i];
        if(memberRec.type_of_member == "primary_owner") {
            primaryMember = memberRec;
        }
    }
        

    useEffect(() => {
        if(locationData.PaymentMethod.Stripe && locationData.PaymentMethod.Stripe.Enabled) {
            triggerStripePromise(locationData.PaymentMethod.Stripe.pKey);
        }


    }, [])


    async function triggerStripePromise(pKey) {
        let stripePromise = await loadStripe(pKey);
        setStripePromise(stripePromise);

        let pMember = getPrimaryOwnerMember(localStorageDatas.members);

        //ready up the stripe parameters
        let stripeParams = {
            ap_transaction_id: transactionId,
            PaymentSName: locationData.PaymentMethod.Stripe.PaymentSName,
            email: pMember.email
        };

        const appearance = {
            theme: 'stripe'
        };

        let suppLength = getSuppLength(localStorageDatas.members);

        if(primaryMember.selected_product[0].item_group_description.indexOf("Accor Plus Explorer Membership") != -1 && suppLength == 0 && isBcSubscriptionEnabled()) {
            setSubscriptionTransaction(true);
            //call Stripe Subscription API
            ApiService.stripeCreateSubscription(stripeParams)
                .then(res => res.json())
                .then((data) => {
                    setClientSecret(data.clientSecret)
                    
                    stripeOptions = {
                        clientSecret: data.clientSecret,
                        appearance
                    };

                    setStripeOptions(stripeOptions);
                    setIsLoaded(true);
                }).catch((err) => {
                    setError(err);
                    setIsLoaded(true);
                });
        } else {
            setSubscriptionTransaction(false);
            //call Stripe Payment Intent API
            ApiService.stripeCreatePaymentIntent(stripeParams)
                .then(res => res.json())
                .then((data) => {
                    setClientSecret(data.clientSecret)

                    stripeOptions = {
                        clientSecret: data.clientSecret,
                        appearance
                    };

                    setStripeOptions(stripeOptions);
                    setIsLoaded(true);
                }).catch((err) => {
                    setError(err);
                    setIsLoaded(true);
                });
        }
    }

    function getSuppLength(members) {
        let suppLength = 0;
        for(let i=0;i<members.length;i++) {
            let member = members[i];
            if(member.type_of_member == "supp") {
                suppLength++;
            }
        }
        return suppLength;
    }

    function getPrimaryOwnerMember(members) {
        let member = {};

        for(let i=0;i<members.length;i++) {
            member = members[i];
            if(member.type_of_member == "primary_owner") {
                break;
            }
        }
        return member;
    }

    function isBcSubscriptionEnabled() {
        let primaryMember = getPrimaryOwnerMember(localStorageDatas.members)
        
        let bc = localStorageDatas.business_categories[primaryMember.selected_product[0].business_category_id] || "";

        if(bc && bc.payment_gateway_description_text && bc.payment_gateway_description_id) {
            //subscription enabled
            return true;
        }

        return false;
    }

    if (error) {
        return <div>Error: {error}</div>;
    } else if (!isLoaded) {
        return (
            <div class="flex content-center justify-center">
                <Spinner />
            </div>
        );
    } else {
        return (
            <div>
                {clientSecret && (
                    <Elements options={stripeOptionsObj} stripe={stripePromiseObj}>
                        <CheckoutForm 
                            locationData={locationData}
                            localStorageDatas={localStorageDatas}
                            goNextStep={goNextStep} 
                            transactionId={transactionId} 
                            clientSecret={clientSecret} 
                            subscriptionTransaction={subscriptionTransaction} 
                        />
                    </Elements>
                )}
            </div>
        )
    }
  }
